<template>
  <div>
    <PageHeader :schema="$schemas.orderService" />
    <PageContent>
      <DynamicListPage
        :schema="$schemas.orderService"
        :service="$api.orderServices"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicListPage from '@/components/dynamics/DynamicListPage';

export default {
  name: 'ListOrderServices',
  components: { PageHeader, PageContent, DynamicListPage },
};
</script>
